import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing } = redesignTheme;

export const useEmptyStateStyles = makeStyles(() => ({
  emptyState: {
    minHeight: 320,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${spacing.xl}px ${spacing.sm}px`,
    color: colors.brownDark,
    textAlign: 'center',
  },
  emptyStateTall: {
    minHeight: 360,
  },
  emptyContent: {
    width: '100%',
    maxWidth: 420,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.sm,
  },
  emptyContentNarrow: {
    maxWidth: 390,
  },
  emptyIcon: {
    width: 48,
    height: 48,
    color: colors.brown,
  },
  emptyTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.xl,
    lineHeight: 'normal',
  },
  emptyDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.intro,
    lineHeight: 'normal',
  },
}));
